










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class WrapperCommonComponent extends Vue {
  @Prop({
    default: null
  })
  public wrapperTitle: string;

  @Prop({
    default: null
  })
  public wrapperBreadcrumb: string;

  @Prop({
    default: 'default'
  })
  public schema: string;
}
